import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { StyledNeutralBadge } from "./styles";
export var NeutralBadge = forwardRef(function NeutralBadge(_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (_jsx(StyledNeutralBadge, __assign({ ref: ref }, props, { children: children })));
});
//# sourceMappingURL=index.js.map